import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"
import VueAxios from "vue-axios"
// import createPersistedState from "vuex-persistedstate"
import * as Cookies from "js-cookie"
// import jwtDecode from "jwt-decode"

Vue.use(Vuex)
Vue.use(VueAxios, axios)

const store = new Vuex.Store({
  // plugins: [createPersistedState({
  // })],

  state: {
    title: "DachauDenktWeiter",
    modalActive: true,
    message: null,
    icon: null,
    filter: false
  },
  mutations: {
    setIcon(state, icon) {
      state.icon = icon
    },
    setCredentials(state, credentials) {
      Cookies.set("credentials", credentials, {
        expires: 1 / 24
      })
    },
    logout(state) {
      state.filter = false
      Cookies.remove("credentials")
    },
    setMessage(state, message) {
      state.message = message
    },
    setFilter(state, value) {
      state.filter = value
    }
  },
  actions: {
    setIcon({
      commit
    }, icon) {
      commit("setIcon", icon)
    },
    setCredentials({
      commit
    }, credentials) {
      commit("setCredentials", credentials)
    },
    logout({
      commit
    }) {
      commit("logout")
    },
    setMessage({
      commit
    }, message) {
      commit("setMessage", message)
    },
    setFilter({
      commit
    }, value) {
      commit("setFilter", value)
    }
  }
})

export default store